export default __webpack_public_path__ + "static/house-0931c06d13a6c47bfb56e2ddca1db592.png";